module.exports = __webpack_public_path__ + "img/hamochFix.ef0e00fb.png";